import { Button, Spinner, TextInput } from "flowbite-react";
import { StyledReportPage } from "../_styles/StyledReportPage";
import { FC } from "react";
import { CondensedCodeDataGrid } from "../../components/CondensedCodeDataGrid";
import { CodeLabel } from "../../components/CodeLabel";
import { useVeloeSaldoContaPage } from "./VeloeSaldoContaPage.hook";

export const VeloeSaldoContaPage: FC = () => {
    const {
        loading, columns, dataSource, handlePesquisar, setFiltro, filtro
    } = useVeloeSaldoContaPage();

    return (
        <StyledReportPage className="shadow rounded-md py-0.5">
            <div className="py-5">
                <h2 className="px-5 mb-4 text-lg font-semibold">Saldo Online</h2>
                <hr />
            </div>

            <div className="flex gap-x-3 px-3 -mt-2 -mb-3 items-end">
                <div>
                    <CodeLabel className="mb-1" htmlFor="inputBases" value="Bases:" />
                    <TextInput
                        id="inputBases"
                        type="text"
                        sizing={"sm"}
                        placeholder="005,006"
                        onChange={(e) => setFiltro({ ...filtro, bases: e.currentTarget.value.split(',') })}
                    />
                </div>

                <div>
                    <CodeLabel className="mb-1" htmlFor="inputCartoes" value="Cartão:" />
                    <TextInput
                        id="inputCartoes"
                        type="text"
                        sizing={"sm"}
                        placeholder="Número do Cartão"
                        onChange={(e) => setFiltro({ ...filtro, cards: e.currentTarget.value.trim().split(',') })}
                    />
                </div>

                <Button
                    id="buttonGerarRelatorio"
                    size={'sm'}
                    disabled={loading}
                    onClick={handlePesquisar}
                    color={'light'}>

                    {loading && <div className={(loading ?? false) ? "mr-3 text-white" : "text-white"}>
                        <Spinner size="sm" light={true} />
                    </div>}

                    {!loading && <span><i className="text-sm" /> Pesquisar</span>}
                    {loading && <span>Pesquisando...</span>}
                </Button>
            </div>

            <CondensedCodeDataGrid
                columns={columns}
                datasource={dataSource}
                header={{ filter: false }}
                readonly={true}
                pagination={{
                    limit: 500,
                    page: 1,
                    pageCount: 1,
                    recordCount: 0
                }}
                hoverable={true}
                striped={true} />

        </StyledReportPage>
    );
}